export const productPrefix = import.meta.env.VITE_APP_PRODUCT_PREFIX;
